const ExitFullScreen = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 30.782 30.782"
    fill="inherit"
  >
    <path
      id="compress_1_"
      data-name="compress (1)"
      d="M6.012,0H24.77a6.024,6.024,0,0,1,6.012,6.012V24.77a6.024,6.024,0,0,1-6.012,6.012H6.012A6.024,6.024,0,0,1,0,24.77V6.012A6.024,6.024,0,0,1,6.012,0Zm8.615,17.382A1.128,1.128,0,0,0,13.5,16.255h-5.9a1.127,1.127,0,1,0,0,2.255h3.179l-4.2,4.2a1.127,1.127,0,1,0,1.594,1.595l4.2-4.2v3.179a1.127,1.127,0,1,0,2.255,0ZM16.255,13.4a1.128,1.128,0,0,0,1.127,1.127h5.9a1.127,1.127,0,1,0,0-2.255H20.105l4.2-4.2a1.128,1.128,0,0,0-1.595-1.595l-4.2,4.2V7.5a1.127,1.127,0,1,0-2.255,0Z"
      fillRule="evenodd"
      fill="inherit"
    />
  </svg>
);

export default ExitFullScreen